import React from 'react';
import Select from 'react-select';

interface SelectDropdownProps {
  data: { value: string; label: string }[];
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean;
  textValueStyle?: React.CSSProperties;
  controlStyle?: React.CSSProperties;
}

/**
 * Dropdown based on the React Select library. This was brought from the event flow.
 * This is not built well and styles are not properly made.
 * But putting this here is a first step.
 */
const SelectDropdown: React.FC<SelectDropdownProps> = ({
  data,
  onChange,
  disabled,
  value,
  textValueStyle,
  controlStyle
}) => {
  const selectedValue = data.find((d) => d.value === value);

  const handleOnChange = (selected) => {
    onChange(selected.value);
  };

  return (
    <Select
      closeMenuOnSelect
      options={data}
      onChange={handleOnChange}
      value={selectedValue}
      isDisabled={disabled}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: 6,
          fontSize: 14,
          height: 44,
          ...controlStyle
        }),
        placeholder: (base) => ({
          ...base,
          color: '#B1B1B1'
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: 'none'
        }),
        option: (base) => ({
          ...base,
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 12,
          paddingBottom: 12,
          fontSize: 14
        }),
        menuList: (base) => ({
          ...base,
          paddingTop: 12,
          paddingBottom: 12
        }),
        singleValue: (base) => ({
          ...base,
          ...textValueStyle
        })
      }}
    />
  );
};

export default SelectDropdown;
